import React, { useEffect } from "react";
import { Form, Row, Col, Input } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import InputCurrency from "../../../common/components/InputCurrency";

const CasePaymentsCost = ({ ...props }) => {
  const { form, caseMaster } = props;

  useEffect(() => {
    const paymentData = caseMaster?.payments?.MAIN[0];
    form.setFieldsValue({ ...paymentData });
  }, [caseMaster?.payments?.MAIN, form]);

  return (
    <BannerCard title="Cost Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="FINES_OWED" label="Cost & Fines Due">
              <InputCurrency style={{ width: "100%" }} readOnly />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="FINES_PAID" label="Amount Paid">
              <InputCurrency style={{ width: "100%" }} readOnly />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="FINES_BALANCE" label="Balance Due">
              <InputCurrency style={{ width: "100%" }} readOnly />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CasePaymentsCost;
